import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MomentModule } from 'angular2-moment';
import { ComponentsModule } from '../../components/components.module';
import { MemberGetMemberRoutingModule } from './member-get-member-routes';
import { KnowTheRulesComponent } from './know-the-rules/know-the-rules.component';
import { ProfileComponent } from './profile/profile.component';
import { InvitesComponent } from './invites/invites.component';
import { VouchersComponent } from './vouchers/vouchers.component';

@NgModule({
  declarations: [
    KnowTheRulesComponent,
    ProfileComponent,
    InvitesComponent,
    VouchersComponent
  ],
  imports: [
    FormsModule,
    MomentModule,
    CommonModule,
    FormsModule,
    ComponentsModule,
    ReactiveFormsModule,
    MemberGetMemberRoutingModule
  ]
})

export class MemberGetMemberModule {}
